import { PointerEvent, useRef } from 'react'

const SWIPE_DISTANCE = 48

export const useReleaseSwipe = (onSwipe: (direction: -1 | 1) => void) => {
    const start = useRef<{ x: number; y: number; pointerId: number } | null>(null)

    return {
        onPointerDown: (event: PointerEvent<HTMLElement>) => {
            if (!event.isPrimary || event.button !== 0) return
            if (event.target instanceof Element && event.target.closest('button, a, input')) return
            start.current = { x: event.clientX, y: event.clientY, pointerId: event.pointerId }
            event.currentTarget.setPointerCapture(event.pointerId)
        },
        onPointerUp: (event: PointerEvent<HTMLElement>) => {
            const origin = start.current
            start.current = null
            if (!origin || origin.pointerId !== event.pointerId) return
            const deltaX = event.clientX - origin.x
            const deltaY = event.clientY - origin.y
            if (Math.abs(deltaX) < SWIPE_DISTANCE || Math.abs(deltaX) <= Math.abs(deltaY)) return
            onSwipe(deltaX < 0 ? 1 : -1)
        },
        onPointerCancel: () => {
            start.current = null
        },
        onLostPointerCapture: () => {
            start.current = null
        },
    }
}
